import { render } from "./ComplaintTypeStep.vue?vue&type=template&id=73c2d0a2"
import script from "./ComplaintTypeStep.vue?vue&type=script&lang=js"
export * from "./ComplaintTypeStep.vue?vue&type=script&lang=js"

import "./ComplaintTypeStep.vue?vue&type=style&index=0&id=73c2d0a2&lang=css"

import exportComponent from "C:\\Users\\ser-mgk\\Documents\\Projekty\\CCS\\__DOPiK\\nowy-formularz-zgloszeniowy\\claim-form-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__